<template>
    <div class="flex flex-wrap justify-evenly max-w-2xl mx-auto mt-10">
        <button
            style="border-radius: 0;padding: 10px;background: white;color: #1825D8;text-transform: uppercase;"
            :disabled="form.busy"
            class="JobOverview__btn btn btn-xl btn-success"
            @click="openModal('accept')"
        >
            Accepter
        </button>

        <button
            style="padding: 10px 30px;border-radius: 0;background: var(--magic-color); border:1px solid white;color: white;text-transform: uppercase;"
            :disabled="form.busy"
            class="JobOverview__btn btn btn-xl btn-danger btn-load"
            onclick="jQuery('.ChatModal .btn').click();"
        >
            Lad os tale pris
        </button>

        <button
            style="border-radius: 0;padding: 10px;background: #ff0000;color: white;text-transform: uppercase;"
            :disabled="form.busy"
            class="JobOverview__btn btn btn-xl btn-danger btn-load"
            @click="decline"
        >
            Afvis
        </button>

        <job-accept-modal
            v-if="currentModal === 'accept'"
            v-bind="{ job, brand }"
            @close="closeModal"
            @open-payment="switchModal('payment-method')"
        ></job-accept-modal>

        <payment-method-modal
            v-if="currentModal === 'payment-method'"
            :team="brand"
            @close="switchModal('accept')"
        ></payment-method-modal>
    </div>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'

export default {
    components: {},

    directives: {},

    mixins: [ManagesModalState],

    props: ['job', 'brand', 'warn'],

    data() {
        return {
            form: new SparkForm({}),
        }
    },

    methods: {
        decline() {
            this.warn(
                'Vælger du at afvise anmodningen, vil du ikke kunne samarbejde med influenten omkring denne kampagne.',
                '',
                'Ja, afvis',
                () =>
                    Spark.post(route('api.job.action', [this.job.id, 'decline']), this.form).then(
                        response => Bus.$emit('jobUpdated', response.data)
                    )
            )
        },
    },
}
</script>
